import ButtonBack from "@/view/components/ButtonBack";
import useAvailableOffersClt from "./useAvailableOffersClt";
import { Spinner } from "@/view/components/ui/spinner";
import { Dialog } from "@/view/components/ui/dialog";
import MakeProposalCard from "../WithdrawSimulation/components/MakeProposalCard";
import { addMoneySimbols } from "@/app/utils/formatMoneyValue";
import NewWithdrawModal from "../WithdrawSimulation/components/NewWithdrawModal";
import { OfferCard } from "./components/OfferCard";
import { ITableClt } from "@/app/services/cltService/getTables";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/view/components/ui/select";
import { Input } from "@/view/components/ui/input";
import { Refresh } from "iconsax-react";

export default function AvailableOffersClt() {
  const {
    list,
    isLoading,
    error,
    selectedTable,
    setSelectedTable,
    installments,
    handleSelectInstallments,
    matricula,
    cnpjEmpresa,
    financedValue,
    setFinancedValue,
    isLoadingAvailableOffers,
    isLoadingFinancedValue,
    isErrorAvailableOffers,
    isErrorFinancedValue,
    handleRefresh,
  } = useAvailableOffersClt();

  if (isLoadingAvailableOffers) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-8 xl:flex-row">
        <Spinner />
      </div>
    );
  }

  if (isErrorAvailableOffers) {
    const errorMessage =
      (error as any)?.response?.data?.message ||
      (error as any)?.message ||
      "Ocorreu um erro ao buscar as ofertas.";

    return (
      <div>
        <ButtonBack label="Ofertas" />
        <div className="flex h-[50vh] flex-col items-center justify-center gap-4">
          <span className="text-base font-semibold text-black01">
            {errorMessage}
          </span>
        </div>
      </div>
    );
  }

  if (!selectedTable && installments.length === 0) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-8 xl:flex-row">
        <span className="text-base font-semibold text-black01">
          Nenhuma oferta encontrada
        </span>
      </div>
    );
  }

  if (!selectedTable && installments.length === 0) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-8 xl:flex-row">
        <span className="text-base font-semibold text-black01">
          Nenhuma oferta encontrada
        </span>
      </div>
    );
  }

  return (
    <div>
      <ButtonBack label="Ofertas" />

      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-5 rounded-2xl border-gray01 sm:min-w-[461px] sm:p-0 md:flex-row md:items-center md:justify-between md:border md:bg-white02 md:p-5 ">
          <div className="flex items-center justify-between gap-5 rounded-2xl bg-white02 p-5 md:gap-10 md:rounded-none md:bg-transparent md:p-0">
            <div>
              <p className="mb-2 text-sm font-normal text-black04">
                Grandino CLT - CONSIGNADO PRIVADO
              </p>

              <div className="flex items-end gap-4">
                <div className="flex flex-col gap-1.5">
                  <label className="text-sm font-medium">Liberado</label>
                  <Input
                    value={addMoneySimbols(
                      financedValue ?? selectedTable?.ValorLiquidoCliente,
                    )}
                    className="h-10 text-lg"
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, "");
                      const numericValue = Number(onlyNumbers) / 100;

                      setFinancedValue(numericValue);
                    }}
                  />
                </div>

                {!isLoading &&
                  installments.length > 0 &&
                  (selectedTable?.ValorLiquidoCliente || 0) > 0 && (
                    <div>
                      <p className="mb-1.5 text-sm font-medium">Parcelas</p>
                      <Select
                        value={selectedTable?.Prazo?.toString() || ""}
                        onValueChange={(value) =>
                          handleSelectInstallments(Number(value))
                        }
                      >
                        <SelectTrigger className="w-16 text-lg">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {installments.map((quota) => (
                            <SelectItem
                              className="text-lg"
                              key={quota.value}
                              value={quota.value!.toString()}
                              onClick={(e: React.MouseEvent) =>
                                e.stopPropagation()
                              }
                            >
                              {quota.label}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  )}

                <button
                  type="button"
                  onClick={handleRefresh}
                  disabled={isLoading}
                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-input bg-background disabled:opacity-50"
                >
                  <Refresh size={18} />
                </button>
              </div>
            </div>
          </div>

          <Dialog>
            <MakeProposalCard
              disabled={
                selectedTable?.ValorLiquidoCliente === 0 ||
                isLoading ||
                isErrorFinancedValue
              }
            />
            <NewWithdrawModal
              table={selectedTable}
              type="CLT"
              matricula={matricula}
              cnpjEmpresa={cnpjEmpresa}
            />
          </Dialog>
        </div>

        <div className="flex flex-col gap-4">
          {isErrorFinancedValue && (
            <div className="flex justify-center pt-20">
              <span className="text-base font-semibold text-black01">
                {(error as any)?.response?.data?.message ||
                  (error as any)?.message ||
                  "Ocorreu um erro ao buscar as ofertas."}
              </span>
            </div>
          )}

          {isLoadingFinancedValue && (
            <div className="flex justify-center pt-20">
              <Spinner />
            </div>
          )}

          <div className="flex gap-4 overflow-x-auto p-4 max-sm:snap-x max-sm:snap-mandatory">
            {(list as ITableClt[])?.map((offer: ITableClt) => (
              <div
                key={offer.ID}
                className="max-sm:flex-shrink-0 max-sm:snap-center"
              >
                <OfferCard
                  selected={selectedTable?.ID === offer.ID}
                  onClick={() => setSelectedTable(offer)}
                  offer={offer as unknown as ITableClt}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
